import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { BUILDER_STEPS, BuilderStep, STEP_LABELS } from './builderSteps';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the setup; each part uses its own slice of it */
import styles from './Builder.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface BuilderNavProps {
  step: BuilderStep;
  onStep: (step: BuilderStep) => void;
  /** What a step set ("Forests · playlists first"); the default line of the step otherwise. */
  subs?: Partial<Record<BuilderStep, string>>;
  /** No draft yet: only step 1 opens. */
  locked?: boolean;
}

/** The step list of the setup (design outreach-v2 b1 `wz-nav`). A done step stays open. */
const BuilderNavComponent: React.FC<BuilderNavProps> = ({ step, onStep, subs = {}, locked = false }) => {
  const intl = useIntl();
  const current = BUILDER_STEPS.indexOf(step);
  const items = useMemo(
    () =>
      BUILDER_STEPS.map((item, index) => {
        const isDone = index < current;
        const isOn = item === step;
        return (
          <li key={item}>
            <button
              type="button"
              className={clsx(styles.navItem, isOn && styles.navOn, isDone && styles.navDone)}
              onClick={() => onStep(item)}
              disabled={locked && item !== 'song'}
              aria-current={isOn ? 'step' : undefined}
              data-testid={`builder-nav-${item}`}
            >
              <span className={styles.navNumber}>{isDone ? '✓' : index + 1}</span>
              <span>
                {intl.formatMessage(STEP_LABELS[item].title)}
                <small>{subs[item] ?? intl.formatMessage(STEP_LABELS[item].sub)}</small>
              </span>
            </button>
          </li>
        );
      }),
    [current, intl, locked, onStep, step, subs]
  );
  return <ol className={styles.nav}>{items}</ol>;
};

export const BuilderNav = TypedMemo(BuilderNavComponent);
